var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"contact",attrs:{"href":_vm.contact.link,"width":"50px","height":"50px"}},[_c('div',{staticClass:"overlay"}),_c('img',{staticClass:"icon",attrs:{"src":require(`../assets/${_vm.contact.img}`)}}),_c('p',{staticClass:"label"},[_vm._v(_vm._s(_vm.contact.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }